import { IConfigService } from '@cs/performance-manager/shared';

export abstract class TabbedPageConfigService implements IConfigService {
	moduleName = 'tabbedPage';


}
